module.exports = __webpack_public_path__ + "img/Image_14.31c5d57b.png";